import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { DictionaryTagEffects } from './tag.effects';
import { StoreModule } from '@ngrx/store';
import { DICTIONARY_TAG_REDUCER_TOKEN, dictionaryTagReducerProvider, rootReducerKey } from './tag.reducer';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(rootReducerKey, DICTIONARY_TAG_REDUCER_TOKEN),
    EffectsModule.forFeature([DictionaryTagEffects])
  ],
  providers: [
    dictionaryTagReducerProvider
  ]
})
export class DictionaryTagStoreModule {
}
